import { IBaseModel } from "./IBaseModel";
import { IMedia, IProduct } from "./Product";

export interface CartItem {
  id: string;
  name: string;
  description: string;
  price: number;
  size: string;
  sizes: string[];
  color: string;
  colors: string[];
  quantity: number;
  images: string[];
  media: IMedia[];
  slug: string;
}

export interface CartState {
  items: CartItem[];
}


export interface ICart extends IBaseModel {
  userId: String;
  status: CartStatus;
  totalPrice: number;
  finalPrice: number;
  discount: number;
  shippingCharge: number;
  cartItems: ICartItem[];
}

export enum CartStatus {
  Active = 'Active',
  Abandoned = 'Abandoned',
  Completed = 'Completed'
}

export interface ICartItem {
  id: string;
  productId: string;
  productVariantId?: string;
  /**
       * No. of items
       */
  quantity: number;
  /**
   * price per item
   */
  price: number;
  /**
   * discount amount
   */
  discount: number;
  /**
   * Percentage of discount applied - can be null, if it's a flat discount.
   */
  discountPercentage?: number;
  /**
   * total amount after discount
   */
  itemTotal: number;

  // readonly
  product: IProduct;
  productVariant?: IProductVariant;
  availableCount:number;
}


export interface IProductVariant {
  id: string;
  productId: string;
  isPrimary: boolean; // Primary Variant / Group By
  variantMasterName: string; // Size, Color values
  variantMasterId: string;
  name: string;
  price: number;
  compareAtPrice: number;
  costPerItem: number;
  profit: number; // Auto generated
  margin: number; // Auto generated        

  // readonly
  product?: IProduct;
}
